export function Loading({ what }: { what: string }) {
  return (
    <p className="text-sm text-slate-500" role="status">
      Loading {what}…
    </p>
  );
}
